module.exports = __webpack_public_path__ + "img/Weapon_186.a67519e5.png";